/** Central allowlist for `import.meta.env` keys; use `ConfigProvider.value(name)` for reads. */
const CONFIG = Object.freeze({
  backendHost: '$VITE_APP_API_URI',
  oidcAuthority: '$VITE_APP_OIDC_AUTHORITY',
  oidcClientId: '$VITE_APP_OIDC_CLIENT_ID',
  oidcScope: '$VITE_APP_OIDC_SCOPE',
  trustedReferrer: '$VITE_APP_TRUSTED_REFERRER',
  client: '$VITE_APP_CLIENT',

  strapiApiBaseUrl: '$VITE_APP_STRAPI_BASE_URL',

  swaggerUITryItOut: '$VITE_APP_ENABLE_SWAGGER_TRY_IT_OUT',
  swaggerUIDisableSyntaxHighlighting:
    '$VITE_APP_DISABLE_SWAGGER_SYNTAX_HIGHLIGHTING',

  liferayBaseUrl: '$VITE_APP_LIFERAY_BASE_URL',
  liferayClientId: '$VITE_APP_LIFERAY_CLIENT_ID',
  /** Exposed to the client bundle like all `VITE_*` vars — confirm policy before storing real secrets. */
  liferayClientSecret: '$VITE_APP_LIFERAY_CLIENT_SECRET',

  apiQuickFilters: '$VITE_APP_API_QUICK_FILTERS',

  errorDialogEnabled: '$VITE_APP_ERROR_DIALOG_ENABLED',
  initialLoadingIconEnabled: '$VITE_APP_INITIAL_LOADING_ICON_ENABLED',

  logoDark: '$VITE_APP_LOGO_DARK',
  logoLight: '$VITE_APP_LOGO_LIGHT',

  portfolioModuleEnabled: '$VITE_APP_PORTFOLIO_MODULE_ENABLED',
  dataDictionaryModuleEnabled: '$VITE_APP_DATADICTIONARY_MODULE_ENABLED',
  azureAdModuleEnabled: '$VITE_APP_AZUREAD_MODULE_ENABLED',
  subscriptionManagerModuleEnabled:
    '$VITE_APP_SUBSCRIPTION_MANAGER_MODULE_ENABLED',

  walkthroughEnabled: '$VITE_APP_WALKTHROUGH_ENABLED',
});

export default class ConfigProvider {
  static get CONFIG() {
    return CONFIG;
  }

  /**
   * @param {string} name — key from `CONFIG`
   * @returns {string|boolean|null} Resolved env value, literal, or `null` if unknown key or unset env (empty string is preserved).
   */
  static value(name) {
    if (!(name in CONFIG)) {
      return null;
    }

    const value = CONFIG[name];

    if (!value) {
      return null;
    }

    if (value.startsWith('$VITE_APP_')) {
      const envName = value.slice(1);
      const resolved = import.meta.env[envName];
      return resolved === undefined ? null : resolved;
    }
    return value;
  }
}
